import { AxiosRequestConfig } from 'axios';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { SectionRelayRequestDto } from '@diritto/common/relay/dtos/section-relay.dtos';
import { RelayApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';

export const useGetSectionsQuery = (query: SectionRelayRequestDto, options?: AxiosRequestConfig) =>
  useQuery({
    queryKey: relayQueryKey.sections(query),
    queryFn: () => RelayApi.sections(query, options),
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 10,
  });

export const prefetchSectionsQuery = (
  queryClient: QueryClient,
  options: AxiosRequestConfig,
  query: SectionRelayRequestDto,
) =>
  queryClient.prefetchQuery({
    queryKey: relayQueryKey.sections(query),
    queryFn: () => RelayApi.sections(query, options),
  });

export const fetchSectionsQuery = (
  queryClient: QueryClient,
  options: AxiosRequestConfig,
  query: SectionRelayRequestDto,
) =>
  queryClient.fetchQuery({
    queryKey: relayQueryKey.sections(query),
    queryFn: () => RelayApi.sections(query, options),
  });
